/** @jsxImportSource @emotion/react */
import { Trans, useLingui } from '@lingui/react/macro';
import { selectTeams } from 'modules/main/store/main-page';
import AvatarGroup from 'modules/main/ui/components/section/components/avatar-group/avatar-group';
import ValueGroup from 'modules/main/ui/components/section/components/value-group/value-group';
import Section from 'modules/main/ui/components/section/section';
import { Pages } from 'modules/navigation/domain/enums/pages';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { theme } from 'styles/theme/theme';
import type { DivProps } from 'typings';
import TeamsAddIcon from 'ud-ui/components/icon/teams-add-icon';
import Text from 'ud-ui/components/text';

interface IProps extends DivProps {
  loading?: boolean;
}

function SectionTeams(props: IProps) {
  const { loading, ...rest } = props;
  const { t } = useLingui();
  const navigate = useNavigate();
  const { total, declared, popular } = useSelector(selectTeams);
  const overflow = Math.max(total - popular.length, 0);

  const values = [
    { label: t`всего`, value: total.toString() },
    { label: t`заявлены`, value: declared.toString() },
  ];

  return (
    <Section
      icon={<TeamsAddIcon />}
      header={t`Команды`}
      buttonText={t`Добавить команду`}
      isShowButton={total === 0}
      onClickButton={() => navigate(Pages.TEAMS.CREATE)}
      onClickExtend={() => navigate(Pages.TEAMS.INDEX)}
      loading={loading}
      {...rest}
    >
      <ValueGroup values={values} className="mb-5" />
      {popular.length ? (
        <div className="flex flex-col gap-3">
          <div className="flex flex-col">
            <Text variant="body-1" color={theme.colors.Gray}>
              <Trans>Популярные</Trans>
            </Text>
            <Text variant="subtitle-2" color={theme.colors.WhiteGray}>
              <Trans>Часто участвуют в турнирах</Trans>
            </Text>
          </div>
          <AvatarGroup avatars={popular.map((item) => item.image)} overflowIndicator={overflow !== 0 ? overflow : undefined} />
        </div>
      ) : (
        <div className="flex flex-col">
          <Text variant="body-1" color={theme.colors.Gray}>
            <Trans>Популярные</Trans>
          </Text>
          <Text variant="subtitle-2" color={theme.colors.WhiteGray}>
            <Trans>В списке нет команд</Trans>
          </Text>
        </div>
      )}
    </Section>
  );
}

export default SectionTeams;
